import { logDispatcher } from "src/app/core/decorators/state.decorators";

export namespace SignalRActions {
    @logDispatcher
    export class SetConnectionId {
        static readonly type = '[MassiveAction] SetConnectionId';
        constructor(public connectionId: string) { }
    }

}
